import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

const InputField = ({
  type = "text",
  label,
  icon: Icon,
  iconRight,
  value,
  onChange,
  placeholder,
  name,
  inputMode,
  disabled = false,
  helperText,
  maxLength,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-full">
      {/* Label */}
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1">
          {label}
        </label>
      )}

      {/* Input wrapper */}
      <div
        className={`
          relative flex items-center
          h-[46px]
          rounded-full
          px-4
          border
          bg-white
          transition
          ${
            disabled
              ? "bg-slate-100 border-slate-200"
              : "border-slate-300 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/30"
          }
        `}
      >
        {/* Left icon */}
        {Icon && (
          <Icon className="text-slate-400 text-lg mr-3 flex-shrink-0" />
        )}

        {/* Input */}
        <input
          type={type === "password" && showPassword ? "text" : type}
          className="
            w-full bg-transparent text-sm text-slate-900
            placeholder:text-slate-400
            focus:outline-none
            disabled:cursor-not-allowed
          "
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          inputMode={inputMode}
          disabled={disabled}
          maxLength={maxLength}
        />

        {/* Right icon / password toggle */}
        {type === "password" ? (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 text-slate-400 hover:text-slate-600"
          >
            {showPassword ? <FiEye /> : <FiEyeOff />}
          </button>
        ) : (
          iconRight && (
            <span className="absolute right-4 text-slate-400">
              {iconRight}
            </span>
          )
        )}
      </div>

      {/* Helper text */}
      {helperText && (
        <p className="mt-1 text-xs text-slate-500">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default InputField;
